import { MessageBox } from 'element-ui';
import dateFns from 'date-fns';
import { delay } from '../../../utils/etc';

export async function confirmIncludeWeekday() {
  try {
    await delay(500);
    await MessageBox.confirm(
      '매주 개설된 수업의 경우 해당 수업의 요일이 포함되어야합니다. 해당 수업의 요일을 포함시키겠습니까?',
      '반복 수업 조건 오류',
      {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        showClose: true,
        distinguishCancelAndClose: true,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false
      }
    );

    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
}

export async function confirmRecurrenceRuleChange() {
  try {
    await delay(500);
    await MessageBox.confirm(
      '변경된 반복 규칙은 향후 모든 수업에 적용됩니다.',
      '수업에 대한 반복 규칙을 변경하시겠습니까?',
      {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        showClose: false,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false
      }
    );
    return true;
  } catch (err) {
    return false;
  }
}

export async function confirmAllBookingCancel(
  allBookings,
  isBookingSystem,
  isDelete = false
) {
  const bookingSystem = isBookingSystem ? '예약' : '수강';
  const actionWord = isDelete ? '삭제' : '수정';
  if (allBookings.length === 0) {
    return true;
  }

  let bookingListHTML = allBookings
    .map(booking => {
      return `
		<li>
			<span>- ${dateFns.format(booking.dt, 'YYYY년 M월 D일 HH:mm')}</span><span>${
        booking.course_name
      }</span>
		</li>`;
    })
    .join('');

  let bookingWarningHTML = `<p class="confirm-description__main">수업 일자와 시간, 수업명은 ${bookingSystem} 내역이 있을 경우 수정이 불가합니다. \
							  아래의 ${bookingSystem} 내역이 확인된 수업의 ${bookingSystem} 내역을 먼저 취소한 후 ${
    isDelete ? '삭제를' : '수정을'
  } 진행해 주시기 바랍니다.</p>\
							  ${
                  isDelete
                    ? ''
                    : '<p class="confirm-description__sub">강사, 정원, 수업 시간(분), 온라인 링크, 반복 규칙(요일)은 언제든지 수정할 수 있습니다.</p>'
                }
            				  <ul class="confirm-booking">${bookingListHTML}</ul>`;

  try {
    await delay(500);
    await MessageBox.confirm(
      bookingWarningHTML,
      `이미 ${bookingSystem ? '예약된' : '수강한'} 내역이 있어 바로 ${
        isDelete ? '삭제가' : '수정이'
      } 불가합니다.`,
      {
        confirmButtonText: '확인',
        cancelButtonText: `모든 ${bookingSystem} 내역 취소하고 수업 ${actionWord}`,
        showClose: false,
        dangerouslyUseHTMLString: true,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false,
        closeOnClickModal: false
      }
    );

    return false;
  } catch (err) {
    return true;
  }
}

export async function confirmDeleteWithAllBookingCancel(isBookingSystem) {
  const bookingSystem = isBookingSystem ? '예약' : '수강';

  try {
    await delay(500);
    await MessageBox.confirm(
      `모든 ${bookingSystem} 내역을 취소한 후 수업을 삭제해주시길 바랍니다.`,
      `${bookingSystem} 내역이 존재합니다.`,
      {
        confirmButtonText: `모든 ${bookingSystem} 내역 취소`,
        cancelButtonText: '확인',
        showClose: false,
        distinguishCancelAndClose: true,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false
      }
    );

    return true;
  } catch (action) {
    return false;
  }
}

export async function confirmDeleteChildCourse() {
  try {
    await delay(500);
    await MessageBox.confirm(
      '본 수업을 삭제하시겠습니까? 삭제 후 복구가 불가합니다.',
      '수업 삭제',
      {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        showClose: false,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false
      }
    );

    return true;
  } catch (err) {
    return false;
  }
}

export async function confirmBulkDelete(isReccurence) {
  let stopDelete = false,
    isBulkDelete = false;

  if (!isReccurence) {
    return {
      stopDelete,
      isBulkDelete
    };
  }

  try {
    await delay(500);
    await MessageBox.confirm(
      '선택된 수업을 포함하여 이후 모든 수업을 삭제하시겠습니까, 아니면 현재 선택된 수업만 삭제하시겠습니까?',
      '반복 개설된 수업을 삭제 중입니다.',
      {
        confirmButtonText: '이 수업만 삭제',
        cancelButtonText: '이후 모든 수업 삭제',
        showClose: true,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false,
        distinguishCancelAndClose: true
      }
    );

    isBulkDelete = false;
  } catch (action) {
    stopDelete = action === 'close';
    isBulkDelete = action !== 'close';
  }

  return {
    isBulkDelete,
    stopDelete
  };
}

export async function confirmAllCourseChange() {
  try {
    await delay(500);
    await MessageBox.confirm(
      '선택된 수업을 포함하여 이후 모든 수업을 변경하시겠습니까, 아니면 현재 선택된 수업만 변경하시겠습니까?',
      '반복 개설된 수업을 수정 중입니다.',
      {
        confirmButtonText: '이 수업만 변경',
        cancelButtonText: '이후 모든 수업 변경',
        showClose: true,
        distinguishCancelAndClose: true,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false
      }
    );

    return 'this-course';
  } catch (action) {
    if (action === 'close') {
      return 'close';
    }

    return 'all-courses';
  }
}

export async function confirmAdminDemoMode() {
  try {
    await delay(500);
    await MessageBox.confirm(
      '전 기능을 무료로 이용하실 수 있는 플랜이 준비되어 있습니다. 직접 체험 후 우리 센터에 맞는지 판단해보세요.',
      '관리자 체험 모드에서는 조회만 가능합니다.',
      {
        confirmButtonText: '지금 바로 플랜 가입',
        cancelButtonText: '계속 이용',
        showClose: false,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white'
      }
    );

    return true;
  } catch (err) {
    return false;
  }
}

export async function confirmOverQuotaChildCourses(allBookings, min) {
  if (allBookings.length === 0) {
    return true;
  }

  let bookingListHTML = allBookings
    .map(booking => {
      return `
		<li>
			<span>- ${dateFns.format(booking.dt, 'YYYY년 M월 D일 HH:mm')}</span><span>${
        booking.course_name
      }</span>
		</li>`;
    })
    .join('');

  let bookingWarningHTML = `<p class="confirm-description__main">수정하고자 한 정원을 이미 초과 예약된 수업이 존재합니다.\
	  						  <br>일괄 적용을 원하실 경우 정원을 ${min}명 이상으로 조정하거나 아래 리스트업된 수업의 예약 내역을 먼저 확인해 주시길 바랍니다.</p>\
            				  <ul class="confirm-booking">${bookingListHTML}</ul>`;

  try {
    await delay(500);
    await MessageBox.confirm(
      bookingWarningHTML,
      '반복 수업 일괄 저장이 불가합니다.',
      {
        showCancelButton: false,
        confirmButtonText: '확인',
        showClose: false,
        dangerouslyUseHTMLString: true,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false,
        closeOnClickModal: false
      }
    );

    return false;
  } catch (err) {
    return true;
  }
}

export async function confirmAllWaitingCancel(allBookings, membershipSystem) {
  const bookingSystem = '대기';
  if (allBookings.length === 0) {
    return true;
  }

  const bookingListHTML = allBookings
    .map(booking => {
      return `
		<li>
            <span>- ${dateFns.format(booking.dt, 'YYYY년 M월 D일 HH:mm')}</span>
            <span>${booking.member_name} (${booking.course_name})</span>
		</li>`;
    })
    .join('');

  const bookingWarningHTML = `<p class="confirm-description__main">새로운 인원 정보로 수정할 경우 아래의 내역은 자동으로 취소 처리됩니다.\
								각 수업 별 대기 리스트가 변동될 수 있으니 반드시 본 내용 숙지하고 진행해 주시길 바랍니다.\
                                </p>\
                                <p class="confirm-description__sub">진행 즉시 일괄적으로 대기 취소 푸시 알림이 전송되고 ${
                                  membershipSystem.long
                                }는 자동 복구됩니다.</p>
                                <ul class="confirm-booking">${bookingListHTML}</ul>`;

  try {
    await delay(500);
    await MessageBox.confirm(
      bookingWarningHTML,
      '이미 대기 내역이 있어 바로 수정이 불가합니다.',
      {
        confirmButtonText: '확인',
        cancelButtonText: `모든 ${bookingSystem} 취소하고 저장`,
        showClose: false,
        dangerouslyUseHTMLString: true,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false,
        closeOnClickModal: false
      }
    );

    return false;
  } catch (err) {
    return true;
  }
}
